import React from 'react';

import styled, { keyframes } from 'styled-components';

const drawCircle = keyframes` 
    0% {
        stroke-dasharray: 0 240;
    }
    100% {
        stroke-dasharray: 240 0;
    }
`;

const drawLine = keyframes` 
    0% {
        stroke-dasharray: 0 48;
    }
    100% {
        stroke-dasharray: 48 0;
    }
`;

const StyledSvg = styled.svg`
    width: 80px;
    height: 80px;
    overflow: visible;
`;

const Circle = styled.path`
    fill: none;
    stroke: ${(props) => props.theme.pink_100};
    stroke-width: 3;
    stroke-dasharray: 240;
    stroke-dashoffset: 180;
    animation: ${drawCircle} 1s ease-out forwards;
`;

const CrossLine = styled.path`
    fill: none;
    stroke: ${(props) => props.theme.pink_100};
    stroke-width: 3;
    stroke-linecap: round;
    stroke-dasharray: 48;
    stroke-dashoffset: 48;
    animation: ${drawLine} 0.5s ease-out ${({ delay }) => delay}s forwards;
`;

export const AnimatedIconFail = () => {
    return (
        <StyledSvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 80 80">
            <Circle d="M5 40C5 20.67 20.67 5 40 5C59.33 5 75 20.67 75 40C75 59.33 59.33 75 40 75C20.67 75 5 59.33 5 40Z" />
            <CrossLine d="M26.94 26.94L53.06 53.06" delay={1} />
            <CrossLine d="M53.06 26.94L26.94 53.06" delay={1.5} />
        </StyledSvg>
    );
};
